<template>
    <section>
        <section>
            <h3 class="text-uppercase mt-4">Account information</h3>
            <hr class="bar my-3" />
            <form>
                <div class="form-group row">
                    <div class="col-12">
                        <photo-upload
                            :user="user"
                            :profile-status="{ has_photo: false }"
                        ></photo-upload>
                    </div>
                </div>

                <div v-show="isUserOrganizationSuperUser()" class="form-group row">
                    <label for="organization_name" class="col-sm-4 col-form-label font-weight-bold"
                        >Organization Name</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="organization_name"
                            name="organization_name"
                            placeholder=""
                            v-model="organization.name"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label for="first_name" class="col-sm-4 col-form-label font-weight-bold"
                        >First Name</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="first_name"
                            name="first_name"
                            placeholder="First Name"
                            v-model="payload.first_name"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label
                        for="last_name"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Last Name</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="last_name"
                            name="last_name"
                            placeholder="Last Name"
                            v-model="payload.last_name"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label
                        for="phone"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                    >
                        Primary phone
                    </label>
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="phone"
                            name="phone"
                            placeholder="Primary phone"
                            v-mask="'(###) ###-#### ####'"
                            v-model="payload.primary_phone"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label
                        for="email"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >E-mail Address (user name)</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="email"
                            class="form-control"
                            id="email"
                            placeholder="E-mail address"
                            v-model="payload.email"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label
                        for="email"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Password</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="password"
                            class="form-control"
                            id="password"
                            name="password"
                            placeholder="Password"
                            v-model="payload.password"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label
                        for="password_verify"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Verify Password</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="password"
                            class="form-control"
                            id="password_verify"
                            name="password_verify"
                            placeholder="Verify Password"
                            v-model="payload.password_verify"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Signature</label
                    >
                    <div class="col-sm-8">
                        <div class="" v-show="payload.signature">
                            <img
                                id="signature"
                                v-if="payload.signature"
                                class="signatureWrapper"
                                :src="payload.signature"
                                alt=""
                            />
                        </div>
                        <div v-show="!payload.signature" class="mt-3">
                            <p>No signature found.</p>
                        </div>
                        <signature :user="user" :canvas-id="'settings'"></signature>
                    </div>
                </div>
            </form>
        </section>

        <section>
            <h4 class="text-uppercase mt-4 mb-3">My Public Profile</h4>
            <p>
                When a parent or professional clicks on your image or name this is the information
                that will appear to them.
            </p>
            <form>
                <div class="form-group row">
                    <label for="title" class="col-sm-4 col-form-label font-weight-bold"
                        >Title</label
                    >
                    <div class="col-sm-8">
                        <select
                            v-model="payload.title"
                            id="title"
                            name="title"
                            class="form-control"
                            required
                        >
                            <option selected disabled>Please select a type</option>
                            <option v-for="title in titles" :value="title">{{ title }}</option>
                            <option value="other">Other (specify)</option>
                        </select>
                        <input
                            v-if="payload.title && !titles.includes(payload.title)"
                            v-model="title_other"
                            placeholder="Specify title"
                            name="title_other"
                            type="text"
                            class="form-control mt-2"
                            required
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="last_name" class="col-sm-4 col-form-label font-weight-bold"
                        >Brief Bio</label
                    >
                    <div class="col-sm-8">
                        <textarea
                            class="form-control w-100"
                            id="bio"
                            name="bio"
                            placeholder="Brief Bio"
                            v-model="payload.biography"
                        ></textarea>
                    </div>
                </div>
            </form>
        </section>

        <section>
            <h4 class="text-uppercase mt-4 mb-3">Address</h4>
            <form>
                <div class="form-group row">
                    <label
                        for="address1"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Number & street</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="address1"
                            name="address1"
                            placeholder="Number & Street"
                            v-model="payload.address1"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label
                        for="address2"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Address line 2</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="address2"
                            name="address2"
                            placeholder="Address line 2"
                            v-model="payload.address2"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label
                        for="city"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >City</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="city"
                            name="city"
                            placeholder="City"
                            v-model="payload.city"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label
                        for="state"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >State</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="state"
                            name="state"
                            placeholder="State"
                            v-mask="'AA'"
                            v-model="payload.state"
                            required
                        />
                        <div>
                            <small
                                v-if="errors.state && errors.state.length"
                                v-for="e in errors.state"
                                class="font-italic text-danger"
                                >{{ e }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label
                        for="zip"
                        class="col-sm-4 col-form-label font-weight-bold text-capitalize"
                        >Zip code</label
                    >
                    <div class="col-sm-8">
                        <input
                            type="text"
                            class="form-control"
                            id="zip"
                            name="zip"
                            placeholder="Zip Code"
                            v-mask="'#####-####'"
                            v-model="payload.zip"
                            required
                        />
                        <div>
                            <small
                                v-if="errors.zip && errors.zip.length"
                                v-for="e in errors.zip"
                                class="font-italic text-danger"
                                >{{ e }}
                            </small>
                        </div>
                    </div>
                </div>

                <div
                    v-if="success.account_information && success.account_information.length"
                    class="row my-3"
                >
                    <div class="col-12">
                        <div class="alert alert-success">
                            <a href="#" class="close" data-dismiss="alert">&times;</a>
                            <strong>Success!</strong> {{ success.account_information }}
                        </div>
                    </div>
                </div>

                <errors :errors="errors"></errors>

                <button
                    class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                    id="save-changes"
                    name="save-changes"
                    dusk="save-changes"
                    @click.prevent="saveChanges()"
                >
                    Save Changes
                </button>
            </form>
        </section>
    </section>
</template>

<script>
import { errors } from "../../plugins/errors";
import { helpers } from "../../plugins/helpers";
import Signature from "../ui/Signature";
import PhotoUpload from "../widgets/PhotoUploadWidget";
export default {
    name: "AccountInformation",
    mixins: [errors],
    props: ["user", "organization", "titles"],
    components: {
        Signature,
        PhotoUpload,
    },
    data() {
        return {
            payload: { ...this.user },
            title_other: "",
            success: {
                account_information: null,
            },
        };
    },
    mounted() {
        this.payload = { ...this.user };
    },
    watch: {
        user() {
            this.payload = { ...this.user };
            if (this.user) {
                this.treatOtherTitle();
            }
        },
    },
    methods: {
        isUserOrganizationSuperUser() {
            return _.get(this.organization, "pivot.role", null) === "super_user";
        },

        validatePayload(payload) {
            let errors = {
                zip: [],
                state: [],
            };
            let valid = true;
            if (!payload.zip) {
                valid = false;
                errors.zip.push("The zip field is required.");
            }
            if (payload.zip && ![5, 10].includes(payload.zip.length)) {
                valid = false;
                errors.zip.push("Zip should be either 5 or 9 characters.");
            }
            if (!payload.state) {
                valid = false;
                errors.state.push("The state field is required.");
            }
            if (payload.state && payload.state.length !== 2) {
                valid = false;
                errors.state.push("State should be two characters.");
            }
            if (!valid) {
                this.setErrors(errors);
            }
            return valid;
        },

        saveChanges() {
            this.setErrors();
            this.success.account_information = null;

            let payload = { ...this.payload };
            if (!this.validatePayload(payload)) return;
            helpers.toggleSpinner("save-changes");

            if (!this.titles.includes(payload.title)) {
                payload.title = this.title_other;
            }

            axios
                .patch(`/api/users/${this.user.id}`, payload)
                .then(response => {
                    this.payload = response.data.data;
                    this.treatOtherTitle();
                    if (this.isUserOrganizationSuperUser()) {
                        return this.saveOrganizationSettings();
                    }
                })
                .then(r => {
                    helpers.toggleSpinner("save-changes");
                    this.success.account_information = "Your account information was saved.";
                })
                .catch(e => {
                    helpers.toggleSpinner("save-changes");
                    this.setErrors(_.get(e, "response.data.errors", {}));
                });
        },

        // returns a Promise
        saveOrganizationSettings() {
            // only attempt to save the organization name
            const payload = {
                name: this.organization.name,
            };

            // save organization settings
            return axios({
                method: "patch",
                url: `/api/organizations/${this.organization.id}`,
                data: payload,
            });
        },

        treatOtherTitle() {
            if (!this.titles.includes(this.payload.title)) {
                this.title_other = this.payload.title;
                this.payload.title = "other";
            }
        },
    },
};
</script>

<style scoped></style>
